import { stringify } from 'qs';
import request from '@/utils/request'; // 查询告知问卷信息

export const queryNotice = params => request('/v1/insure/queryNoticeQuestion', {
  method: 'POST',
  data: params
}); // 根据文件id获取文件内容

export const fetchFileById = params => request('/v1/document/queryDocumentDetail', {
  method: 'POST',
  data: params
}); // 根据文件名称获取文件

export const previweFile = params => request(`/v1/document/previewFile?${stringify(params)}`, {
  method: 'GET'
});